import { hitApi, ObservableAjax } from '__common/utils/api';
import { UPDATE_USER_PREFERENCES, USER_PREFERENCES_SAVE_ERROR } from 'actions';
import { UserPreferencesActionTypes } from 'actionsConstants';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export function sendNewUserPreferences(action$: Observable<any>) {
  return action$.pipe(
    ofType(UserPreferencesActionTypes.SEND_NEW_USER_PREFERENCES),
    switchMap(action => {
      const userPreferences: userPreferences = action.payload.userPreferences;
      return ObservableAjax({
        until$: action$.pipe(ofType(UserPreferencesActionTypes.SEND_NEW_USER_PREFERENCES)),
        onSuccess: UPDATE_USER_PREFERENCES,
        onError: USER_PREFERENCES_SAVE_ERROR,
        onErrorMessage: 'Cannot save user preferences',
        link: hitApi('put', `api/v1/user_preferences/`, { ...userPreferences }),
      });
    })
  );
}
